const translations = {
    farm: 'Farm',
    farmIsRequired: 'Farm is required'
};

export default translations;
